export const storeParams = <T>(selected: readonly T[], all: readonly unknown[]) =>
  selected.length > 0 && selected.length < all.length ? { store_ids: [...selected] } : {}
